import { IconButton } from '@mui/material';
import type { CustomerPortalInvoice } from '@vy/types';
import { useGetCustomerPortalInvoicePdfMutation } from '../../../../../../hooks/requests/use-customer-portal';
import { saveInvoiceAsFile } from '../../../../../../services/invoices-file-saver';
import { runMutation } from '../../../../../../utils/vy-mutation';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

type CustomerPortalInvoicesTableDownloadButtonProps = {
  invoice: CustomerPortalInvoice;
  token: string;
};

export const CustomerPortalInvoicesTableDownloadButton: React.FC<
  CustomerPortalInvoicesTableDownloadButtonProps
> = ({ invoice, token }) => {
  const downloadInvoicePdfMutation = useGetCustomerPortalInvoicePdfMutation();

  const handleDownloadInvoicePdf = async (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    await runMutation(
      downloadInvoicePdfMutation,
      {
        token,
        invoiceId: invoice.id,
      },
      {
        pending: 'Downloading invoice...',
        success: 'Invoice downloaded',
        error: 'Failed to download invoice',
      },
      {
        onSuccess: async ({ encodedPdf }) => {
          await saveInvoiceAsFile(encodedPdf, invoice.customerName, invoice.name);
        },
      },
    );
  };

  return (
    <IconButton
      onClick={handleDownloadInvoicePdf}
      aria-label="Download invoice"
      sx={{
        width: 32,
        height: 32,
        borderRadius: '6px',
        border: '1px solid #E7E8E9',
        color: '#323232',
        backgroundColor: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#F5F6FA',
        },
      }}
    >
      <FileDownloadOutlinedIcon />
    </IconButton>
  );
};
